export const validateUserFirstName = (first_name) => {
  // if (!first_name) {
  //   return "First name is required";
  // }

  // if (first_name.length < 2) {
  //   return "First name must be at least 2 characters";
  // }

  return true;
};

export const validateUserLastName = (last_name) => {
  // if (!last_name) {
  //   return "Last name is required";
  // }

  // if (last_name.length < 2) {
  //   return "Last name must be at least 2 characters";
  // }

  return true;
};

export const validateUserEmail = (email) => {
  // if (!email) {
  //   return "Email is required";
  // }

  if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
    return "Invalid email format";
  }

  return true;
};

export const validateBirthdayDate = (birthday_date) => {
  // if (!birthday_date || birthday_date.trim() === "") {
  //   return "Birth date is required";
  // }
  const today = new Date();
  const birthDate = new Date(birthday_date);
  if (birthDate >= today) {
    return "Birth date must be in the past";
  }

  return true;
};
export const validateUserGender = (gender) => {
  if (!gender) {
    return "gender is required";
  }

  if (gender.length < 2) {
    return "gender must be at least 2 characters";
  }

  return true;
};
export const validateUserBio = (bio) => {
  if (!bio) {
    return "bio is required";
  }

  if (bio.length < 2) {
    return "Bio must be at least 2 characters";
  }

  return true;
};
export const validateUserLocation = (location) => {
  if (!location) {
    return "Location is required";
  }

  if (location.length < 2) {
    return "Location must be at least 2 characters";
  }

  return true;
};
export const validateUserSexualOrientation = (sexualOrientation) => {
  if (!sexualOrientation) {
    return "First name is required";
  }

  if (sexualOrientation.length < 2) {
    return "SexualOrientation must be at least 2 characters";
  }

  return true;
};
export const validateUserEthnicity = (ethnicity) => {
  if (!ethnicity) {
    return "Ethnicity is required";
  }

  if (ethnicity.length < 2) {
    return "Ethnicity must be at least 2 characters";
  }

  return true;
};
export const validateUserAnnualIncome = (annualIncome) => {
  if (!annualIncome) {
    return "annualIncome is required";
  }

  if (annualIncome.length < 2) {
    return "annualIncome must be at least 2 characters";
  }

  return true;
};
export const validateUserProfileImg = (profileImg) => {
  if (!profileImg) {
    return "ProfileImg is required";
  }

  // If it's a File object, check if it exists
  if (profileImg instanceof File) {
    return true;
  }

  // If it's a string (URL), check length
  if (typeof profileImg === 'string' && profileImg.length < 2) {
    return "profileImg must be at least 2 characters";
  }

  return true;
};

export const validateProfileForm = (formData) => {
  const firstNameValidation = validateUserFirstName(formData.firstName);
  if (firstNameValidation !== true) {
    return firstNameValidation;
  }

  const lastNameValidation = validateUserLastName(formData.lastName);
  if (lastNameValidation !== true) {
    return lastNameValidation;
  }

  const emailValidation = validateUserEmail(formData.email);
  if (emailValidation !== true) {
    return emailValidation;
  }

  const birthdayDateValidation = validateBirthdayDate(formData.DOB);
  if (birthdayDateValidation !== true) {
    return birthdayDateValidation;
  }
  const genderValidation = validateUserGender(formData.gender);
  if (genderValidation !== true) {
    return genderValidation;
  }
  const bioValidation = validateUserBio(formData.bio);
  if (bioValidation !== true) {
    return bioValidation;
  }
  const locationValidation = validateUserLocation(formData.location);
  if (locationValidation !== true) {
    return locationValidation;
  }
  const sexualOrientationValidation = validateUserSexualOrientation(
    formData.sexualOrientation,
  );
  if (sexualOrientationValidation !== true) {
    return sexualOrientationValidation;
  }
  const ethnicityValidation = validateUserEthnicity(formData.ethnicity);
  if (ethnicityValidation !== true) {
    return ethnicityValidation;
  }
  const annualIncomeValidation = validateUserAnnualIncome(
    formData.annualIncome,
  );
  if (annualIncomeValidation !== true) {
    return annualIncomeValidation;
  }
  const profileImgValidation = validateUserProfileImg(formData.profileImg);
  if (profileImgValidation !== true) {
    return profileImgValidation;
  }

  if (!formData.publicImageUsageConsent) {
    return "You must agree to the public usage of your images";
  }

  return true;
};
export const validateProfileViewerForm = (formData) => {
  const firstNameValidation = validateUserFirstName(formData.firstName);
  if (firstNameValidation !== true) {
    return firstNameValidation;
  }

  const lastNameValidation = validateUserLastName(formData.lastName);
  if (lastNameValidation !== true) {
    return lastNameValidation;
  }

  const emailValidation = validateUserEmail(formData.email);
  if (emailValidation !== true) {
    return emailValidation;
  }

  const birthdayDateValidation = validateBirthdayDate(formData.DOB);
  if (birthdayDateValidation !== true) {
    return birthdayDateValidation;
  }
  const genderValidation = validateUserGender(formData.gender);
  if (genderValidation !== true) {
    return genderValidation;
  }
  const locationValidation = validateUserLocation(formData.location);
  if (locationValidation !== true) {
    return locationValidation;
  }
  const sexualOrientationValidation = validateUserSexualOrientation(
    formData.sexualOrientation,
  );
  if (sexualOrientationValidation !== true) {
    return sexualOrientationValidation;
  }
  const ethnicityValidation = validateUserEthnicity(formData.ethnicity);
  if (ethnicityValidation !== true) {
    return ethnicityValidation;
  }
  const annualIncomeValidation = validateUserAnnualIncome(
    formData.annualIncome,
  );
  if (annualIncomeValidation !== true) {
    return annualIncomeValidation;
  }
  const profileImgValidation = validateUserProfileImg(formData.profileImg);
  if (profileImgValidation !== true) {
    return profileImgValidation;
  }

  return true;
};
